/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ERPSyncCustomer', 'model/ERPSyncCustomerReportERPSyncItemPaginationSlice'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/ERPSyncCustomer'), require('../model/ERPSyncCustomerReportERPSyncItemPaginationSlice'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.ERPSyncCustomerApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.ERPSyncCustomer, root.ForStractionServiceApi.ERPSyncCustomerReportERPSyncItemPaginationSlice);
  }
}(this, function(ApiClient, ERPSyncCustomer, ERPSyncCustomerReportERPSyncItemPaginationSlice) {
  'use strict';

  /**
   * ERPSyncCustomer service.
   * @module api/ERPSyncCustomerApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new ERPSyncCustomerApi. 
   * @alias module:api/ERPSyncCustomerApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the eRPSyncCustomerEditAllPut operation.
     * @callback module:api/ERPSyncCustomerApi~eRPSyncCustomerEditAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * editAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/ERPSyncCustomer>} body 
     * @param {module:api/ERPSyncCustomerApi~eRPSyncCustomerEditAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.eRPSyncCustomerEditAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling eRPSyncCustomerEditAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling eRPSyncCustomerEditAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ERPSyncCustomer/editAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the eRPSyncCustomerGetDataPreviewGet operation.
     * @callback module:api/ERPSyncCustomerApi~eRPSyncCustomerGetDataPreviewGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'String'>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * getDataPreview
     * @param {String} _4SAPIAppID 
     * @param {module:api/ERPSyncCustomerApi~eRPSyncCustomerGetDataPreviewGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<'String'>}
     */
    this.eRPSyncCustomerGetDataPreviewGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling eRPSyncCustomerGetDataPreviewGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['String'];

      return this.apiClient.callApi(
        '/ERPSyncCustomer/getDataPreview', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the eRPSyncCustomerSearchAllSlicesPut operation.
     * @callback module:api/ERPSyncCustomerApi~eRPSyncCustomerSearchAllSlicesPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/ERPSyncCustomerReportERPSyncItemPaginationSlice>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * searchAllSlices
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/ERPSyncCustomer>} body 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.maxCount  (default to 0)
     * @param {Integer} opts.sortMode  (default to 0)
     * @param {String} opts.indicatorIDs  (default to )
     * @param {Date} opts.indicatorStartDate 
     * @param {Date} opts.indicatorEndDate 
     * @param {module:api/ERPSyncCustomerApi~eRPSyncCustomerSearchAllSlicesPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/ERPSyncCustomerReportERPSyncItemPaginationSlice>}
     */
    this.eRPSyncCustomerSearchAllSlicesPut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling eRPSyncCustomerSearchAllSlicesPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling eRPSyncCustomerSearchAllSlicesPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'maxCount': opts['maxCount'],
        'sortMode': opts['sortMode'],
        'indicatorIDs': opts['indicatorIDs'],
        'indicatorStartDate': opts['indicatorStartDate'],
        'indicatorEndDate': opts['indicatorEndDate']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [ERPSyncCustomerReportERPSyncItemPaginationSlice];

      return this.apiClient.callApi(
        '/ERPSyncCustomer/searchAllSlices', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the eRPSyncCustomerSearchSlicePut operation.
     * @callback module:api/ERPSyncCustomerApi~eRPSyncCustomerSearchSlicePutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ERPSyncCustomerReportERPSyncItemPaginationSlice} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * searchSlice
     * @param {String} _4SAPIAppID 
     * @param {module:model/ERPSyncCustomer} body 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.startID  (default to 0)
     * @param {Integer} opts.maxCount  (default to 0)
     * @param {Integer} opts.sortMode  (default to 0)
     * @param {String} opts.indicatorIDs  (default to )
     * @param {Date} opts.indicatorStartDate 
     * @param {Date} opts.indicatorEndDate 
     * @param {module:api/ERPSyncCustomerApi~eRPSyncCustomerSearchSlicePutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ERPSyncCustomerReportERPSyncItemPaginationSlice}
     */
    this.eRPSyncCustomerSearchSlicePut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling eRPSyncCustomerSearchSlicePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling eRPSyncCustomerSearchSlicePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'startID': opts['startID'],
        'maxCount': opts['maxCount'],
        'sortMode': opts['sortMode'],
        'indicatorIDs': opts['indicatorIDs'],
        'indicatorStartDate': opts['indicatorStartDate'],
        'indicatorEndDate': opts['indicatorEndDate']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ERPSyncCustomerReportERPSyncItemPaginationSlice;

      return this.apiClient.callApi(
        '/ERPSyncCustomer/searchSlice', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
